import { TextField } from '@mui/material';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';

type OwnProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = {
    name: TName;
    control: Control<TFieldValues>;
    rules?: Omit<RegisterOptions<TFieldValues, TName>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
} & Omit<DateTimePickerProps<Date, Date>, 'onChange' | 'value' | 'renderInput'>;

export function FormKeyboardDateTimePicker<
    TFieldValues extends FieldValues,
    TName extends FieldPath<TFieldValues>
>({ name, label, rules, control, ...props }: OwnProps<TFieldValues, TName>) {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { value, ref, ...rest }, fieldState: { error } }) => (
                <DateTimePicker
                    showToolbar={false}
                    value={value || null}
                    {...rest}
                    {...props}
                    ref={ref}
                    label={label}
                    renderInput={params => (
                        <TextField
                            size="small"
                            variant="outlined"
                            helperText={error?.message}
                            {...params}
                            error={!!error}
                        />
                    )}
                />
            )}
        />
    );
}
